import { render, staticRenderFns } from "./IbTabs.vue?vue&type=template&id=08f070d9&scoped=true"
import script from "./IbTabs.vue?vue&type=script&lang=js"
export * from "./IbTabs.vue?vue&type=script&lang=js"
import style0 from "./IbTabs.vue?vue&type=style&index=0&id=08f070d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f070d9",
  null
  
)

export default component.exports